import { useState } from "react";
import { useStore } from "../state/store";
import ui from "./ui.module.css";

const EXAMPLE = JSON.stringify(
  { hands: { "0": ["duke", "captain"], "1": ["contessa", "assassin"] }, coins: { "0": 4 } },
  null,
  1,
);

/** Dev-only lobby tools: fill seats with bots, or start from a scenario. */
export function DevPanel() {
  const send = useStore((s) => s.send);
  const [json, setJson] = useState(EXAMPLE);
  const [error, setError] = useState<string>();

  const load = () => {
    try {
      send({ t: "dev", op: { op: "scenario", scenario: JSON.parse(json) } });
      setError(undefined);
    } catch (e) {
      setError((e as Error).message);
    }
  };

  return (
    <details style={{ fontSize: 13, color: "var(--muted)" }}>
      <summary style={{ cursor: "pointer" }}>Dev tools</summary>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
        <button
          type="button"
          className={ui.ghost}
          onClick={() => send({ t: "dev", op: { op: "bots" } })}
        >
          Fill seats with bots
        </button>
        <textarea
          className={ui.input}
          style={{ height: 110, padding: 8, fontSize: 12, fontFamily: "monospace" }}
          value={json}
          onChange={(e) => setJson(e.target.value)}
        />
        {error && <div style={{ color: "var(--loss)" }}>{error}</div>}
        <button type="button" className={ui.ghost} onClick={load}>
          Start from scenario
        </button>
      </div>
    </details>
  );
}
